(() => {
  const initBlogSearch = (section) => {
    if (!section || section.dataset.blogSearchReady === 'true') return;

    const searchInput = section.querySelector('[data-blog-search-input]');
    if (!searchInput) return;

    const articleCards = Array.from(section.querySelectorAll('.blog-listing .article.grid-item'));
    const emptyState = section.querySelector('[data-blog-search-empty]');
    const queryValue = section.querySelector('[data-blog-search-query]');

    const normalize = (value) => (value || '').toLowerCase().trim();

    const filterArticles = () => {
      const query = normalize(searchInput.value);
      let visibleCount = 0;

      articleCards.forEach((card) => {
        const articleText = normalize(card.textContent);
        const matches = query === '' || articleText.includes(query);

        card.classList.toggle('is-hidden-by-blog-search', !matches);
        if (matches) visibleCount += 1;
      });

      if (!emptyState) return;

      if (queryValue) {
        queryValue.textContent = searchInput.value.trim();
      }

      emptyState.hidden = query === '' || visibleCount > 0;
    };

    searchInput.addEventListener('input', filterArticles);
    filterArticles();

    section.dataset.blogSearchReady = 'true';
  };

  const initAllBlogSearches = (root = document) => {
    const sections = root.querySelectorAll('[data-section-type="blog"]');
    sections.forEach(initBlogSearch);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initAllBlogSearches();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAllBlogSearches(event.target);
  });
})();
